import types from 'redux/types';

const getUserServlet = (data) => {
  return {
    type: types.REQUEST_API_USERSERVLET,
    ...data,
  };
};

const clearUserServlet = () => {
  return {
    type: types.REQUEST_CLEAR_USERSERVLET,
  };
};

const getListUsers = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_LIST_USERS,
  };
};

const createUser = (data) => {
  return {
    ...data,
    type: types.REQUEST_CREATE_USERS,
  };
};

const deleteUsers = (data) => {
  return {
    ...data,
    type: types.REQUEST_DELETE_USERS,
  };
};

const showDIDs = (data) => {
  return {
    ...data,
    type: types.REQUEST_SHOW_DIDS,
  };
};

const addDIDs = (data) => {
  return {
    ...data,
    type: types.REQUEST_ADD_DIDS,
  };
};

const migrateDIDs = (data) => {
  return {
    ...data,
    type: types.REQUEST_MIGRATE_DIDS,
  };
};

const deleteVirtualPhone = (data) => {
  return {
    ...data,
    type: types.REQUEST_DELETE_VIRTUALPHONE,
  };
};

const addCredits = (data) => {
  return {
    ...data,
    type: types.REQUEST_ADD_CREDITS_USER,
  };
};

const updateUser = (data) => {
  return {
    ...data,
    type: types.REQUEST_UPDATE_USER,
  };
};

const cloneUser = (data) => {
  return {
    ...data,
    type: types.REQUEST_CLONE_USER,
  };
};

const clearDIDs = () => {
  return {
    type: types.CLEAR_SHOW_DIDS,
  };
};

const updateProfileUser = (data) => {
  return {
    ...data,
    type: types.REQUEST_UPDATE_PROFILE,
  };
};

const updateSettings = (data) => {
  return {
    ...data,
    type: types.REQUEST_UPDATE_SETTING,
  };
};

const updateApiSetting = (data) => {
  return {
    ...data,
    type: types.REQUEST_UPDATE_SETTING_API,
  };
};

const updateClickRequest = (data) => {
  return {
    ...data,
    type: types.REQUEST_UPDATE_REQUEST_CLICK,
  };
};

const runNow = (data) => {
  return {
    ...data,
    type: types.REQUEST_BACKUP_NOW,
  };
};

const doRestore = (data) => {
  return {
    ...data,
    type: types.REQUEST_RESTORE,
  };
};

const exportUser = (data) => {
  return {
    ...data,
    type: types.REQUEST_EXPORT_USER,
  };
};

const exportCreditStatus = (data) => {
  return {
    ...data,
    type: types.REQUEST_EXPORT_CREDIT_STATUS,
  };
};

const exportCampainStatus = (data) => {
  return {
    ...data,
    type: types.REQUEST_EXPORT_CAMPAIN,
  };
};

const regenerateAPIKey = (data) => {
  return {
    ...data,
    type: types.REQUEST_REGENERATE_API_KEY,
  };
};

const saveLayoutMonitoring = (data) => {
  return {
    ...data,
    type: types.REQUEST_SAVE_LAYOUT_MONITORING,
  };
};

const saveLayoutContactGroup = (data) => {
  return {
    ...data,
    type: types.REQUEST_SAVE_LAYOUT_CONTACT,
  };
};

export default {
  saveLayoutMonitoring,
  saveLayoutContactGroup,
  regenerateAPIKey,
  exportCampainStatus,
  exportCreditStatus,
  exportUser,
  doRestore,
  runNow,
  updateApiSetting,
  updateSettings,
  updateProfileUser,
  cloneUser,
  updateUser,
  addCredits,
  clearDIDs,
  showDIDs,
  addDIDs,
  migrateDIDs,
  deleteVirtualPhone,
  createUser,
  deleteUsers,
  getListUsers,
  getUserServlet,
  clearUserServlet,
  updateClickRequest,
};
